import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = loading, false = anonymous, object = logged-in user
  const [user, setUser] = useState(null);

  // On mount, check whether the session cookie is still valid by hitting /api/auth/me.
  // 401 → anonymous. Any other error also treated as anonymous (fail closed).
  useEffect(() => {
    let cancelled = false;
    axios.get('/api/auth/me')
      .then(r => { if (!cancelled) setUser(r.data.user); })
      .catch(() => { if (!cancelled) setUser(false); });
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (username, password) => {
    const r = await axios.post('/api/auth/login', { username, password });
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const signup = useCallback(async (username, password) => {
    const r = await axios.post('/api/auth/signup', { username, password });
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await axios.post('/api/auth/logout'); }
    catch { /* even if server fails, clear local state */ }
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
